<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="validateAndSubmit" onsubmit="return false;">
          <v-text-field
            v-model="dev_key"
            type="password"
            label="Developer-Key"
            :rules="key_rules"
          >
          </v-text-field>
          <v-btn
            type="submit"
            rounded
            block
            class="primary"
            :disabled="loading"
            :loading="loading"
            >Submit</v-btn
          >
        </v-form>
        <v-alert v-model="alert.show" :type="alert.alert_type" class="ma-4">{{
          alert.text
        }}</v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Entrance",
  data() {
    return {
      loading: false,
      dev_key: null,
      valid: null,
      key_rules: [v => !!v || "Key cannot be empty!"],
      alert: { show: false, alert_type: "error", text: "" }
    };
  },
  methods: {
    validateAndSubmit() {
      this.loading = true;
      this.alert = { show: false, alert_type: "error", text: "" };

      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("user/try_dev_auth", { dev_token: this.dev_key })
          .then(() => {
            this.loading = false;
            this.$router.push("/");
          })
          .catch(() => {
            this.loading = false;
            this.alert = {
              show: true,
              alert_type: "error",
              text: "The Token you provided is invalid."
            };
          });
      }
    }
  }
};
</script>

<style scoped></style>
